var Handlebars = require("../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"Modal-backOrder\">\r\n  <a href=\"#\" data-remodal-action=\"cancel\" class=\"Modal-close Icon Icon--cross\"></a>\r\n\r\n  <div class=\"Modal-iframe\">\r\n    <iframe src=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"productFormUrl") || (depth0 != null ? lookupProperty(depth0,"productFormUrl") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"productFormUrl","hash":{},"data":data,"loc":{"start":{"line":5,"column":17},"end":{"line":5,"column":35}}}) : helper)))
    + "\"  frameborder=\"0\"></iframe>\r\n  </div>\r\n</div>\r\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./assets/tmpl/client/modal/productForm.hbs
// module id = 1126
// module chunks = 1